const MoonIcon = () => {
  return (
    <svg fill="none" viewBox="0 0 36 38" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M33.584 26.073C32.4349 26.3348 31.241 26.4727 30.016 26.4727C20.8864 26.4727 13.4848 18.8094 13.4848 9.35621C13.4848 6.75558 14.045 4.29042 15.0472 2.08301C7.63254 3.77203 2.08398 10.615 2.08398 18.7998C2.08398 28.253 9.48555 35.9163 18.6152 35.9163C25.2332 35.9163 30.9432 31.8895 33.584 26.073Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.5"
      />
    </svg>
  )
}

export default MoonIcon
